import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'ui-buttons',
  templateUrl: './buttons.component.html',
  // řada tlačítek; na úzké obrazovce se zalamuje
  host: { class: 'flex flex-wrap items-center gap-4' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonsComponent {}
